














































import axios from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Conversation } from '@/models/order/Conversation';
import { User } from '@/models/account/User';

@Component
export default class ChatPanel extends Vue {
    @Prop({ required: true })
    public orderId!: string;

    public message: string = '';

    public loadingChat: boolean = true;
    public sending: boolean = false;

    public chat: Conversation|null = null;

    get user (): User {
        return this.$store.getters['auth/user'];
    }

    public onFilesChange (name: string, files: FileList) {
        const formData = new FormData();

        if (!files.length) {
            return;
        }

        Array.from(Array(files.length).keys())
            .map((file) => {
                formData.append(name, files[file], files[file].name);
            });

        this.send(formData);
    }

    public getChatMessageClass(sentBy: number) {
        const base = 'chat-panel__message';

        return this.user.id === sentBy
            ? `${base} ${base}--right`
            : `${base} ${base}--left`;
    }

    public fetchConversation () {
        axios.get(`/order/conversation/${this.orderId}`)
            .then((response) => {
                this.chat = response.data;
                this.loadingChat = false;
                this.scrollToBottom();
            })
            .catch((error) => {
                this.$store.dispatch('shared/error', error.response);
            });
    }

    public scrollToBottom () {
        const elem = this.$refs.conversation as HTMLElement;

        setTimeout(() => {
            elem.scrollTo(0, elem.scrollHeight);
        }, 50);
    }

    public onSubmit () {
        const formData = new FormData();
        formData.append('message', this.message);

        this.send(formData)
            .then(() => {
                this.message = '';
            });
    }

    public send (data: FormData) {
        this.sending = true;

        return new Promise((resolve, reject) => {
            axios.post(`/order/conversation/${this.orderId}`, data)
                .then(() => {
                    this.fetchConversation();
                    this.sending = false;
                    resolve();
                })
                .catch((error) => {
                    this.$store.dispatch('shared/error', error.response);
                    reject();
                });
        })

        
    }

    public created () {
        this.fetchConversation()
    }
}
